import { getRouteApi, type RegisteredRouter, type RouteIds, type SearchParamOptions } from "@tanstack/react-router";


const removeEmpty = <T extends Record<string, unknown>>(obj: T): Partial<T> => {
	return Object.fromEntries(
		Object.entries(obj).filter(([_, value]) => value !== "" && value != null)
	) as Partial<T>;
};

export default function useFilters<
	TId extends RouteIds<RegisteredRouter["routeTree"]>,
	TSearchParams extends SearchParamOptions<RegisteredRouter, TId, TId>["search"]
>(routeId: TId) {
	const routeApi = getRouteApi<TId>(routeId);
	const navigate = routeApi.useNavigate();
	const filters = routeApi.useSearch();

	const setFilters = (partialFilters: Partial<TSearchParams>) => // @ts-expect-error I don't know how to fix the type here, but it's working :)
		navigate({
			search: (prev) => (removeEmpty({ ...prev, ...partialFilters }))
		});

	const resetFilters = () => navigate({ search: {} as TSearchParams });

	return { filters, setFilters, resetFilters };
}